<p *ngIf="message | async else elseBlock">{{ message | async }}</p>
<ng-template #elseBlock>
  <app-loading-mask></app-loading-mask>
</ng-template>
